import { render, staticRenderFns } from "./ChessQzone.vue?vue&type=template&id=3ccfa376&scoped=true&"
import script from "./ChessQzone.vue?vue&type=script&lang=js&"
export * from "./ChessQzone.vue?vue&type=script&lang=js&"
import style0 from "./ChessQzone.vue?vue&type=style&index=0&id=3ccfa376&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccfa376",
  null
  
)

export default component.exports